import React from 'react';
import { AlertTriangle, Users, Calendar, TrendingDown, Settings, Frown, BarChart3, UserX } from 'lucide-react';

const painPoints = [
  { icon: Calendar, title: 'Mishandled Appointments', description: 'Double bookings, no-shows, and scheduling chaos killing your reputation' },
  { icon: UserX, title: 'Confused Customers', description: 'Clients frustrated with booking difficulties and poor communication' },
  { icon: Users, title: 'Disoriented Team', description: 'Staff wasting time on manual tasks instead of serving clients' },
  { icon: TrendingDown, title: 'Outdated Marketing', description: 'Missing opportunities to attract and retain customers effectively' },
  { icon: Settings, title: 'Clunky Systems', description: 'Multiple disconnected tools creating inefficiency and errors' },
  { icon: Frown, title: 'Stressed Out Staff', description: 'Team burnout from juggling too many manual processes' },
  { icon: BarChart3, title: 'Stagnant Growth', description: 'Revenue plateauing due to operational inefficiencies' },
  { icon: AlertTriangle, title: 'Frustrated Management', description: 'Lack of clear insights making it impossible to make good decisions' }
];

const PainPoints: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
            Are These Problems Draining Your Salon's Success?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Every day you don't address these issues, you're losing money, customers, and sanity. 
            Here's what's really costing your business:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {painPoints.map((point, index) => {
            const IconComponent = point.icon;
            return (
              <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border-l-4 border-red-500">
                <div className="flex items-center mb-4">
                  <IconComponent className="h-8 w-8 text-red-500 mr-3" />
                  <h3 className="font-bold text-gray-900">{point.title}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{point.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-2xl font-semibold text-red-600 mb-4">
            Sound familiar? You're not alone.
          </p>
          <p className="text-lg text-gray-700">
            The good news? There's a solution that addresses every single one of these problems.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PainPoints;